<div class="dialog">
  <app-dialog-header>
    {{
      (mode === "create" ? "AI_TOKENS.CREATE_MODEL" : "AI_TOKENS.EDIT_MODEL")
        | translate
    }}
  </app-dialog-header>

  <form [formGroup]="form" (ngSubmit)="save()">
    <div class="dialog-body">
      <mat-form-field appearance="outline" class="row w-100 m-b-15">
        <mat-label>{{ "GENERALS.PROVIDER" | translate }}</mat-label>
        <input matInput formControlName="provider" placeholder="bedrock" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="row w-100 m-b-15">
        <mat-label>{{ "AI_TOKENS.MODEL_ID" | translate }}</mat-label>
        <input
          matInput
          formControlName="modelId"
          placeholder="eu.anthropic.claude-sonnet-4-6"
        />
      </mat-form-field>

      <mat-form-field appearance="outline" class="row w-100 m-b-25">
        <mat-label>{{ "AI_TOKENS.INPUT_PRICE_LABEL" | translate }}</mat-label>
        <input
          matInput
          type="number"
          formControlName="inputPricePerMillionCents"
        />
        <mat-hint>{{ "AI_TOKENS.INPUT_PRICE_HINT" | translate }}</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" class="row w-100 m-b-25">
        <mat-label>{{ "AI_TOKENS.OUTPUT_PRICE_LABEL" | translate }}</mat-label>
        <input
          matInput
          type="number"
          formControlName="outputPricePerMillionCents"
        />
        <mat-hint>{{ "AI_TOKENS.OUTPUT_PRICE_HINT" | translate }}</mat-hint>
      </mat-form-field>
    </div>

    <div class="dialog-footer">
      <button
        type="button"
        (click)="cancel()"
        class="btn gray-bg m-r-15"
        [disabled]="submitting"
      >
        {{ "GENERALS.CANCEL" | translate }}
      </button>
      <button
        type="submit"
        class="btn orange-bg"
        [disabled]="form.invalid || submitting"
      >
        {{ "GENERALS.SAVE" | translate }}
      </button>
      <div class="clear"></div>
    </div>
  </form>
</div>
